import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, ROUTES } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OriginalFooterComponent } from './components/footer/original-footer.component';
import { OriginalHeaderComponent } from './components/header/original-header.component';
import { OriginalShellComponent } from './components/shell/original-shell.component';
import { OriginalInactivityModalComponent } from './components/inactivity-modal/original-inactivity-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DateLocalePipe } from '@app/shared/pipes/date-locale.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { FeatureService } from '@app/shared/services/feature.service';
import { ContentEditorResolver } from '@app/shared/services/content-editor.resolver';

@NgModule({
    imports: [
        CommonModule, //
        NgbModule,
        TranslateModule.forChild(),
        BsDropdownModule.forRoot(),
        SharedModule,
        RouterModule.forChild([]),
    ],
    declarations: [
        OriginalShellComponent, //
        OriginalHeaderComponent,
        OriginalFooterComponent,
        OriginalInactivityModalComponent,
    ],
    providers: [
        DateLocalePipe,
        {
            provide: ROUTES,
            useFactory: (features: FeatureService) => {
                return [
                    {
                        path: '',
                        component: OriginalShellComponent,
                        children: features.getShellChildRoutes('original-shell'),
                        resolve: { contentEditorData: ContentEditorResolver },
                        runGuardsAndResolvers: 'always',
                    },
                ];
            },
            deps: [FeatureService],
            multi: true,
        },
    ],
    exports: [],
})
export class OriginalShellModule {}
